module.exports = __webpack_public_path__ + "img/bruschetta.a49d2d0b.jpg";